module.exports = __webpack_public_path__ + "img/org05.17a114b2.png";